import { FlowNodeModel, NodeType } from '@/types';

const nodeStart: FlowNodeModel = {
    maxChildren: 1,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.HANG_UP,
    ],
    autoChildren: [],
    position: {
        x: 0,
    },
};

const nodeTimeValidation: FlowNodeModel = {
    maxChildren: 2,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.HANG_UP,
    ],
    position: {
        x: -75,
    },
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.timeValidation.inTime',
                component: NodeType.OPEN_EDGE,
                flowType: 'inTime',
                related: null,
                hasErrors: false,
            },
            position: {
                x: -50,
                y: 200,
            },
        },
        {
            data: {
                title: 'connectFlow.node.timeValidation.outOfTime',
                component: NodeType.OPEN_EDGE,
                flowType: 'outOfTime',
                related: null,
                hasErrors: false,
            },
            position: {
                x: 325,
                y: 200,
            },
        },
    ],
};

const playAudioValidation: FlowNodeModel = {
    maxChildren: 1,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.HANG_UP,
    ],
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.playAudio.end',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'end',
            },
            position: {
                x: 135,
                y: 200,
            },
        },
    ],
    position: { x: -75 },
};

const openEdgeValidation: FlowNodeModel = {
    maxChildren: -1,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.HANG_UP,
        NodeType.GO_TO,
        NodeType.GO_TO_CONNECT_FLOW,
    ],
    autoChildren: [],
    position: { x: 0 },
};

const clientInfoValidation: FlowNodeModel = {
    maxChildren: 12,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.HANG_UP,
        NodeType.GO_TO,
        NodeType.GO_TO_CONNECT_FLOW,
    ],
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.clientInfo.timeout',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'timeout',
            },
            sourceHandle: 'timeout',
            position: {
                x: -150,
                y: -30,
            },
        },
        {
            data: {
                title: 'connectFlow.node.clientInfo.invalidOption',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'invalid',
            },
            sourceHandle: 'invalid',
            position: {
                x: -150,
                y: 110,
            },
        },
    ],
    position: { x: 0, y: 250 },
};

const transferToValidation: FlowNodeModel = {
    maxChildren: 2,
    typesChildren: [NodeType.TRANSFER_SURVEY],
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.transferToExtension.noAnswer',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'noAnswer',
            },
            position: {
                x: -50,
                y: 200,
            },
        },
    ],
    position: { x: 0 },
};

const basicValidation: FlowNodeModel = {
    maxChildren: 0,
    typesChildren: [],
    autoChildren: [],
    position: { x: 0 },
};

const transferVirtualAgentValidation: FlowNodeModel = {
    maxChildren: 10,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.HANG_UP,
        NodeType.GO_TO,
        NodeType.GO_TO_CONNECT_FLOW,
    ],
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.transferVirtualAgent.hangupWithoutTransfer',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'hangupWithoutTransfer',
            },
            sourceHandle: 'hangupWithoutTransfer',
            position: {
                x: -150,
                y: 120,
            },
        },
    ],
    position: { x: 0 },
};

const connectFlowCustomValidation: FlowNodeModel = {
    maxChildren: 1,
    typesChildren: [
        NodeType.TIME_VALIDATION,
        NodeType.PLAY_AUDIO,
        NodeType.CLIENT_INFO,
        NodeType.TRANSFER_EXTENSION,
        NodeType.TRANSFER_VIRTUAL_AGENT,
        NodeType.TRANSFER_QUEUE,
        NodeType.TRANSFER_EXTERNAL,
        NodeType.CONNECT_FLOW_CUSTOM,
        NodeType.HANG_UP,
        NodeType.GO_TO,
    ],
    autoChildren: [
        {
            data: {
                title: 'connectFlow.node.connectFlowCustom.end',
                component: NodeType.OPEN_EDGE,
                related: null,
                hasErrors: false,
                flowType: 'end',
            },
            position: {
                x: 135,
                y: 200,
            },
        },
    ],
    position: { x: -75 },
};

export const flowNodeRules = {
    [NodeType.START]: nodeStart,
    [NodeType.TIME_VALIDATION]: nodeTimeValidation,
    [NodeType.PLAY_AUDIO]: playAudioValidation,
    [NodeType.OPEN_EDGE]: openEdgeValidation,
    [NodeType.CLIENT_INFO]: clientInfoValidation,
    [NodeType.TRANSFER_EXTENSION]: transferToValidation,
    [NodeType.TRANSFER_EXTERNAL]: basicValidation,
    [NodeType.TRANSFER_QUEUE]: transferToValidation,
    [NodeType.TRANSFER_SURVEY]: basicValidation,
    [NodeType.TRANSFER_VIRTUAL_AGENT]: transferVirtualAgentValidation,
    [NodeType.CONNECT_FLOW_CUSTOM]: connectFlowCustomValidation,
    [NodeType.HANG_UP]: basicValidation,
    [NodeType.GO_TO]: basicValidation,
    [NodeType.GO_TO_CONNECT_FLOW]: basicValidation,
};
